type MaxHeightListener = (maxHeight: number | undefined) => void;

let scopeIds = new WeakMap<object, string>();
let nextScopeId = 0;
const maxHeightByScopedLocalId = new Map<string, number>();
const listenersByScopedLocalId = new Map<string, Set<MaxHeightListener>>();

const getScopedLocalId = (scope: object, localId: string): string => {
	const existing = scopeIds.get(scope);
	if (existing) {
		return `${existing}:${localId}`;
	}
	const created = `scope-${nextScopeId++}`;
	scopeIds.set(scope, created);
	return `${created}:${localId}`;
};

export function setMaxHeight(scope: object, localId: string, maxHeight: number): void {
	const scopedLocalId = getScopedLocalId(scope, localId);
	maxHeightByScopedLocalId.set(scopedLocalId, maxHeight);
	const listeners = listenersByScopedLocalId.get(scopedLocalId);
	if (!listeners) {
		return;
	}
	for (const listener of listeners) {
		try {
			listener(maxHeight);
		} catch (error) {
			// eslint-disable-next-line no-console
			console.error(`[max-height-store] listener for "${localId}" threw:`, error);
		}
	}
}

export function getMaxHeight(scope: object, localId: string): number | undefined {
	return maxHeightByScopedLocalId.get(getScopedLocalId(scope, localId));
}

export function clearMaxHeight(scope: object, localId: string): void {
	const scopedLocalId = getScopedLocalId(scope, localId);
	maxHeightByScopedLocalId.delete(scopedLocalId);
	listenersByScopedLocalId.delete(scopedLocalId);
}

export function subscribeMaxHeight(
	scope: object,
	localId: string,
	listener: MaxHeightListener,
): () => void {
	const scopedLocalId = getScopedLocalId(scope, localId);
	let listeners = listenersByScopedLocalId.get(scopedLocalId);
	if (!listeners) {
		listeners = new Set();
		listenersByScopedLocalId.set(scopedLocalId, listeners);
	}
	listeners.add(listener);
	return () => {
		const set = listenersByScopedLocalId.get(scopedLocalId);
		if (!set) {
			return;
		}
		set.delete(listener);
		if (set.size === 0) {
			listenersByScopedLocalId.delete(scopedLocalId);
		}
	};
}

export function __resetMaxHeightStoreForTests(): void {
	maxHeightByScopedLocalId.clear();
	listenersByScopedLocalId.clear();
	scopeIds = new WeakMap<object, string>();
	nextScopeId = 0;
}
